// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ItemDeliveryDateHistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/item_delivery_date_history/{item_id}
 */
import type { Orders_DeliveryDateHistoryRow } from './Orders_DeliveryDateHistoryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ItemDeliveryDateHistoryResponseDados {
history: Orders_DeliveryDateHistoryRow[]
}

export type Orders_ItemDeliveryDateHistoryResponse = ApiResponse<Orders_ItemDeliveryDateHistoryResponseDados>;

registerResponseContract('Orders_ItemDeliveryDateHistoryResponse', {
  history: {
    type: 'array',
    required: true,
    items: {
      so_oidh_id:              { type: 'number',  required: true },
      so_oidh_order_item_id:   { type: 'number',  required: true },
      so_oidh_previous_date:   { type: 'string',  required: false },
      so_oidh_new_date:        { type: 'string',  required: true },
      so_oidh_reason:          { type: 'string',  required: true },
      so_oidh_changed_by:      { type: 'string',  required: true },
      so_oidh_changed_by_name: { type: 'string',  required: false },
      so_oidh_changed_at:      { type: 'string',  required: true },
    },
  },
})
